/**
 * Elsa nelle pagine della Pianificazione: una configurazione del componente di
 * chat condiviso, con la stessa forma di Aida e Iris (barra sul bordo, pannello
 * che occupa spazio, casella che cresce).
 *
 * *Estrusione, Linee, Sequenze, Attrezzaggi* — agente della pianificazione,
 * condiviso, senza referente unico.
 *
 * Il suo perimetro è **la decisione di sequenza**: cosa va in macchina, in che
 * ordine, e cosa costa cambiarlo. Gli esempi cambiano con la sezione da cui la
 * apri: chiedere è più facile se ti suggeriscono cosa.
 */
import { ChatAgente } from "@/components/agenti/ChatAgente";

const BASE_PATH = "/api/v1/m2/agente/chat";

const SUGGERIMENTI: Record<string, string[]> = {
  cruscotto: [
    "Come sta il piano?",
    "Quali macchine sono sovraccariche?",
    "Quali durate non sono credibili?",
  ],
  piano: [
    "Dove sta L-SP27-T208?",
    "Quanto costa passare da T006 a T208?",
    "Perché questa lavorazione sta qui?",
  ],
  simulazione: [
    "E se l'estrusore 2020 si ferma giovedì?",
    "Quanti cambi stampo posso risparmiare?",
    "E se sposto la S46 sul 2022?",
  ],
  fabbisogno: [
    "Cosa serve estrudere per primo?",
    "Per quali commesse serve la S46?",
    "Quanti articoli non sono mappati?",
  ],
  impostazioni: [
    "Quanto costa un cambio stampo?",
    "Quali stampi girano sul 2022?",
    "Che velocità ha la famiglia SP?",
  ],
};

export function ElsaDock({
  sezione,
  aperta,
  onApertaChange,
}: {
  sezione: string;
  aperta: boolean;
  onApertaChange: (v: boolean) => void;
}) {
  return (
    <ChatAgente
      aperta={aperta}
      onApertaChange={onApertaChange}
      nome="Elsa"
      stato="assistente pianificazione"
      basePath={BASE_PATH}
      modo="inline"
      benvenuto={
        "Ciao! Posso rispondere sul piano di produzione, il carico delle macchine e i " +
        "cambi stampo — e provare gli scenari: «e se il 2020 si ferma giovedì?»."
      }
      suggerimenti={SUGGERIMENTI[sezione] ?? SUGGERIMENTI.cruscotto}
    />
  );
}
